import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Service from "../../services/JenisTinggalService";
import {message} from "antd";

export const initialState = {
    loading: false,
    dataJenisTinggal: [],
    dataJenisTinggalByID:[],
    showMessage:false,
    message:''
}


export const getDataJenisTinggal = createAsyncThunk('ref/jenis_tinggal',async (data, { rejectWithValue }) => {
    try {
        const response = await Service.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataJenisTinggalByID = createAsyncThunk('ref/jenis_tinggalbyid',async (data, { rejectWithValue }) => {
    const {token,id,id_jadwal}=data;
    try {
        const response = await Service.getDataByID(token,id,id_jadwal)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const jenisTinggalSlice = createSlice({
    name: 'jenis_tinggal',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.dataJenisTinggal = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataJenisTinggal.fulfilled, (state, action) => {
                state.loading = false
                state.dataJenisTinggal = action.payload
            })
            .addCase(getDataJenisTinggal.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataJenisTinggal.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataJenisTinggal = action.payload
            })
            .addCase(getDataJenisTinggalByID.fulfilled, (state, action) => {
                state.loading = false
                state.dataJenisTinggalByID = action.payload
            })
            .addCase(getDataJenisTinggalByID.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataJenisTinggalByID.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataJenisTinggalByID = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = jenisTinggalSlice.actions

export default jenisTinggalSlice.reducer
